module.exports = __webpack_public_path__ + "img/Monitor_BG.dc1af46b.jpg";